import { toast } from "sonner";
import { account, database, storage } from "./appwrite";
import { ID, Query } from "appwrite";

export const addUser = async (userData) => {
  console.log("Adding user with data:", userData);
  
  const response = await database.createDocument(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_COLLECTION_ID,
    userData.userId,
    userData
  );

  return response;
};

export const getUserByDocument = async (userId) => {
  try {
    const response = await database.getDocument(
      process.env.REACT_APP_APPWRITE_DATABASE_ID,
      process.env.REACT_APP_APPWRITE_COLLECTION_ID,
      userId
    );

    return response;
  } catch (error) {
    if (error.code === 404) {
      return null;
    }
    throw error;
  }
};

export const getUsers = async (userId) => {
  const response = await database.listDocuments(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_COLLECTION_ID,
    [Query.equal("userId", userId)]
  );

  console.log("Hello");
  console.log(process.env.REACT_APP_APPWRITE_DATABASE_ID);

  return response.documents[0] ?? null;
};

export const getAllUsers = async (query = []) => {
  const response = await database.listDocuments(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_COLLECTION_ID,
    [ ...query, Query.orderDesc("$createdAt")]
  );

  return response.documents ?? null;
};

export const updateUser = async (userId, userData) => {
  console.log("Updating user with ID:", userData);
  const response = await database.updateDocument(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_COLLECTION_ID,
    userId,
    {
      name: userData.name,
      username: userData.username,
      email: userData.email,
      balance: parseFloat(userData.balance),
      avatar: userData.avatar,
      wallet_address: userData.wallet_address,
      reservedEth: parseFloat(userData.reservedEth),
    },
    
  );

  return response;
};

export const deleteUser = async (userId) => {
  const response = await database.deleteDocument(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_COLLECTION_ID,
    userId
  );

  return response;
};

export const handleLogout = async () => {
  try {
    await account.deleteSession("current"); // End Appwrite session
  } catch (err) {
    console.warn("Session already deleted or not logged in:", err);
  }

  localStorage.removeItem("user"); // Or use clear() if you want to remove all
  toast.success("Logged out successfully");
  // navigate('/login'); // Redirect to login or homepage
};

// Storage functions
export async function uploadImage(file) {
  try {
    const result = await storage.createFile(
      process.env.REACT_APP_APPWRITE_BUCKET_ID, // Your bucket ID
      ID.unique(), // File ID, can be 'unique()' to auto-generate
      file // The File object from input
    );

    const previewUrl = storage.getFileView(
      process.env.REACT_APP_APPWRITE_BUCKET_ID,
      result.$id
    );

    console.log("File uploaded successfully:", previewUrl);
    return { previewUrl, result };
  } catch (error) {
    console.error("Error uploading:", error);
  }
}

// ART Functions
export const addArt = async (artData) => {
  const response = await database.createDocument(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_ART_COLLECTION_ID,
    ID.unique(),
    { ...artData, minted: false }
  );

  return response;
};

export const getArtByDocument = async (artId) => {
  try {
    const response = await database.getDocument(
      process.env.REACT_APP_APPWRITE_DATABASE_ID,
      process.env.REACT_APP_APPWRITE_ART_COLLECTION_ID,
      artId,
    );

    return response;
  } catch (error) {
    if (error.code === 404) {
      return null;
    }
    throw error;
  }
};

export const getArts = async (userId) => {
  const response = await database.listDocuments(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_ART_COLLECTION_ID,
    [Query.equal("userId", userId) ]
  );
  
  return response.documents ?? null;
};

export const getAllArts = async (query = []) => {
  const response = await database.listDocuments(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_ART_COLLECTION_ID,
    [
      Query.select(["*", "userId.*"]),
      ...query,
      Query.orderDesc("$createdAt")
    ]
  );

  return response.documents ?? null;
};

export const updateArt = async (ArtId, ArtData) => {
  console.log("Updating Art with ID:", ArtId, ArtData);
  const response = await database.updateDocument(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_ART_COLLECTION_ID,
    ArtId,
    {
      ...ArtData
    }
  );

  return response;
};

export const deleteArt = async (ArtId) => {
  const response = await database.deleteDocument(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_ART_COLLECTION_ID,
    ArtId
  );

  return response;
};


// Club Functions
export const addClub = async (clubData) => {
  console.log("Adding club with data:", clubData);
  console.log(process.env.REACT_APP_APPWRITE_CLUB_COLLECTION_ID);
  console.log("Unique ID", ID.unique())

  const response = await database.createDocument(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_CLUB_COLLECTION_ID,
    ID.unique(),
    { ...clubData }
  );

  return response;
};

export const getClubByDocument = async (clubId) => {
  try {
    const response = await database.getDocument(
      process.env.REACT_APP_APPWRITE_DATABASE_ID,
      process.env.REACT_APP_APPWRITE_CLUB_COLLECTION_ID,
      clubId,
    );

    return response;
  } catch (error) {
    if (error.code === 404) {
      return null;
    }
    throw error;
  }
};

export const getClubs = async (userId) => {
  const response = await database.listDocuments(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_CLUB_COLLECTION_ID,
    [Query.equal("userId", userId) ]
  );
  
  return response.documents ?? null;
};

export const getAllClub = async (query = []) => {
  const response = await database.listDocuments(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_CLUB_COLLECTION_ID,
    [
      Query.select(["*", "owner.*"]),
      ...query,
      Query.orderDesc("$createdAt")
    ]
  );

  return response.documents ?? null;
};

export const updateClub = async (ClubId, ClubData) => {
  console.log("Updating Club with ID:", ClubId, ClubData);
  const response = await database.updateDocument(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_CLUB_COLLECTION_ID,
    ClubId,
    {
      ...ClubData
    }
  );

  return response;
};

export const deleteClub = async (ClubId) => {
  const response = await database.deleteDocument(
    process.env.REACT_APP_APPWRITE_DATABASE_ID,
    process.env.REACT_APP_APPWRITE_CLUB_COLLECTION_ID,
    ClubId
  );

  return response;
};
